import { Component, Inject } from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { BuilderService } from '../../builder-services/builder.service'
import { Observable } from 'rxjs'
import { AppSettingsService } from 'src/app/settings/services/app-settings.service'
import { DiscordService } from 'src/app/builder-services/discord.service'
import { MixpanelService } from 'src/app/tracking/mixpanel.service'
import { LoginService } from 'src/app/login/login.service'
import { Router } from '@angular/router'
import { SubscriptionFlowService } from 'src/app/subscription-flow/subscription-flow.service'
import { stripeService } from '../payment/stripe.service'
import { BillingService } from '../billing/billing.service'

export interface FincartConfirmData {
  title: string
  governorate: string
  price: string
}
export interface DialogData {
  name: string
}

@Component({
  selector: 'works-dialog',
  templateUrl: './works-dialog.component.html',
  styleUrls: ['./works-dialog.component.scss']
})
export class WorksDialogComponent {
  message = ''
  currentGifIndex = 0

  gifList = [
    'assets/gifs/new gifs/choose temp.gif',
    'assets/gifs/new gifs/add block and edits.gif',
    'assets/gifs/new gifs/add product and category.gif',
    'assets/gifs/new gifs/analytics.gif',
    'assets/gifs/new gifs/build apk.gif'
    // Add more paths to your GIFs as needed
  ]
  gifRemoved: boolean = false
  projectData: any
  showMore = false
  displayedFeatures: any[] = []
  hiddenFeatures: any[] = []
  priceId: any
  newPackage: any

  constructor(
    public dialogRef: MatDialogRef<WorksDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public builderService: BuilderService,
    private appSettingsService: AppSettingsService,
    private discordService: DiscordService,
    public mixPanel: MixpanelService,
    public loginService: LoginService,
    private router: Router,
    public SubscriptionFlow: SubscriptionFlowService,
    public stripeService: stripeService,
    public billing: BillingService
  ) {}

  ngOnInit() {
    this.getProjectActiveFeatures()
    this.billing.getSelectedPackage().subscribe((pkg) => {
      this.newPackage = pkg
    })
    setTimeout(() => {
      this.gifRemoved = true
    }, 2500)
    this.loadNextGif()
  }

  getProjectActiveFeatures(): void {
    const cacheResponse = this.builderService.cacheProjectReq.response
    this.projectData = this.getProjectData(cacheResponse)
    this.priceId = cacheResponse?.premium[0]?.stripe_subscription_id
    if (cacheResponse) {
      const matchingPackages = this.getMatchingPackages(cacheResponse, this.SubscriptionFlow.package?.type)

      if (matchingPackages) {
        const filteredFeatures = this.getFilteredFeatures(matchingPackages[0].features)
        this.displayedFeatures = this.getDisplayedFeatures(filteredFeatures)
        this.hiddenFeatures = this.getHiddenFeatures(filteredFeatures)
      }
    }
  }

  private getProjectData(cacheResponse: any): any {
    return cacheResponse?.premium?.[0] || null
  }

  private getMatchingPackages(cacheResponse: any, packageType: string): any[] {
    return cacheResponse?.package?.filter((pkg: any) => pkg.type === packageType) || []
  }

  private getFilteredFeatures(features: any[]): any[] {
    const checkIconPath = 'assets/images/PricingPage/check.png'
    return features.filter((feature: any) => feature.icon === checkIconPath)
  }

  private getDisplayedFeatures(features: any[]): any[] {
    return features.slice(0, 4)
  }

  private getHiddenFeatures(features: any[]): any[] {
    return features.slice(4)
  }

  toggleFeatures() {
    this.showMore = !this.showMore
  }

  onNoClick(): void {
    this.dialogRef.close()
  }

  get currentGifPath() {
    return this.gifList[this.currentGifIndex]
  }

  loadNextGif() {
    this.currentGifIndex = (this.currentGifIndex + 1) % this.gifList.length
  }

  completeTour(dialogOrder: any) {
    this.builderService.checklist[dialogOrder].done = true
    this.dialogRef.close()
    localStorage.setItem('checklist', JSON.stringify(this.builderService.checklist))
  }

  closeDialog = (dialogName: string) => {
    localStorage.setItem(dialogName, 'closed')
    this.dialogRef.close()
  }
  claimOffer = (dialogName: string) => {
    localStorage.setItem(dialogName, 'closed')
    this.dialogRef.close()
    this.router.navigate(['/billing'])
  }

  submitFeedback(comment: string) {
    this.message = comment
    if (this.message === '') {
      this.message = 'N/A'
    }
    if (this.builderService.starRating === 0) {
      this.builderService.starRating = 'N/A'
    }
    // this.sendMessageToDiscord();
    this.setFeedback(this.message).subscribe((result: any) => {
      this.mixPanel.track('onboarding_feedback ', {
        comment: this.message,
        rating: this.builderService.starRating
      })
      this.dialogRef.close()
    })
  }

  // sendMessageToDiscord() {
  //   // console.log(this.message)
  //   let content = 'rating : ' + this.builderService.starRating + ' and comment : ' + this.message + ' from ' + this.loginService.getCurrentUser().username
  //   this.discordService.sendMessage( content, "Feedback" )
  //     .subscribe(
  //       () => {
  //         console.log('Message sent to Discord successfully!');
  //         // Handle success
  //       },
  //       error => {
  //         console.error('Error sending message to Discord:', error);
  //         // Handle error
  //       }
  //     );
  // }

  setFeedback(comment: string) {
    return new Observable<any>((observer) => {
      this.appSettingsService.upsertSettingsByType(String(this.builderService.selectedProject), 'onboarding', { feedback_comment: comment, feedback_rating: this.builderService.starRating })
        .then((response) => {
          observer.next(response) // Notify the observer that the operation is complete
          observer.complete() // Complete the Observable
        })
        .catch((error) => {
          observer.error(error) // Notify the observer of an error
        })
    })
  }

  reactivateSubscription() {
    const userConfirmed = confirm('Are you sure you want to reactive the subscription?')
    if (userConfirmed) {
      this.stripeService.reactivateSubscription().subscribe(
        (response) => {
          console.log('Subscription Reactivated:', response)
          // alert('Subscription Reactivated Successfully');
          this.closeDialog('cancelled')
          // Navigate to the current page (simulating a refresh)
          setTimeout(() => {
            this.router.navigate(['/']).then(() => {
              window.location.reload() // Ensures fresh data load
            })
          }, 500)
        },
        (error) => {
          console.error('Error reactivating subscription:', error)
        }
      )
    }
  }

  cancel(): void {
    this.dialogRef.close(false)
  }

  confirm(): void {
    this.dialogRef.close(true)
  }

  get fincartData() {
    return this.data.name === 'fincartConfirm'
      ? (
          this.data as DialogData & {
            finData: {
              title: string
              governorate: string
              price: string
            }
          }
        ).finData
      : null
  }
}
